import React, { Component } from 'react'
import MlsAutocomplete from '../../util/auto_complete/MlsAutocomplete'

export default class MlsInput extends Component {
  state = {
    mls: ''
  }

  handleMlsChange = (mls) => {
    this.setState({ mls: mls.mls_id })
  }

  renderMlsDropdown() {
    return (
      <div className="form-section">
        <input type="hidden" name={this.idStr("mls_validation")} value={this.state.mls} />
        <label>MLS Info</label>
        <MlsAutocomplete
          mlsStore={this.props.mlsStore}
          onSelect={this.handleMlsChange}
          />
      </div>
    )
  }

  idStr(str) {
    return `${str}_${this.props.validationId}`
  }

  render() {
    const { mls } = this.state

    return (
      <div className="mls-input">
        {this.renderMlsDropdown()}
        <label htmlFor={this.idStr("agent_id")}>Agent Id</label>
        <input id={this.idStr("agent_id")} type="text" name={`mls[${mls}][agent_id]`} />
        <label htmlFor={this.idStr("office_id")}>Office Id</label>
        <input id={this.idStr("office_id")} type="text" name={`mls[${mls}][office_id]`} />
        <label htmlFor={this.idStr("broker_first_name")}>Broker First Name</label>
        <input id={this.idStr("broker_first_name")} type="text" name={`mls[${mls}][broker_first_name]`} />
        <label htmlFor={this.idStr("broker_last_name")}>Broker Last Name</label>
        <input id={this.idStr("broker_last_name")} type="text" name={`mls[${mls}][broker_last_name]`} />
        <label htmlFor={this.idStr("broker_email")}>Broker Email</label>
        <input id={this.idStr("broker_email")} type="text" name={`mls[${mls}][broker_email]`} />
      </div>
    )
  }
}




// WEBPACK FOOTER //
// client/components/util/Form/mls.js